// decode and encode XML
const xmlSpecialToEscapedOneMap: Record<string, string> = {
    '&': '&amp;',
    '"': '&quot;',
    '<': '&lt;',
    '>': '&gt;',
};
const escapedOneToXmlSpecialMap: Record<string, string> = {
    '&amp;': '&',
    '&quot;': '"',
    '&#034;': '"',
    '&lt;': '<',
    '&gt;': '>',
};
export function encodeXml(string: string | nullish) {
    if (!string) return '';
    return string.replace(/([&"<>])/g, function (_str, item) {
        return xmlSpecialToEscapedOneMap[item];
    });
}
export function decodeXml(string: string | nullish) {
    if (!string) return '';
    return string.replace(/(&quot;|&lt;|&gt;|&amp;|&#034;)/g, function (_str, item) {
        return escapedOneToXmlSpecialMap[item];
    });
}
